'use client'

import { FC } from 'react'

import CustomerCaseStudyBox from '@/components/CustomerCaseStudyBox'
import usePayhawkNumCalcs from '@/hooks/usePayhawkNumCalcs'

const PayhawkCaseStudyBox: FC<{}> = () => {
    return (
        <CustomerCaseStudyBox
            reference={'/customers/payhawk'}
            sx={{
                backgroundColor: '#143230',
            }}
            chipLabels={[`Expense management`, `Emission calculations`, `API`]}
            subText={
                'With Lune, we’ve aligned Payhawk’s offerings with sustainability. Not just because it’s given us a competitive edge, but because it’s the right thing to do for our planet.'
            }
            mainText={`200+ Payhawk clients adopt carbon reporting feature in 6 months`}
            avatar={{
                title: 'Raquel Orejas',
                subtitle: `Product Marketing Manager at Payhawk`,
            }}
            counterBox={{
                adoption: `200+ customers`,
                counterCb: usePayhawkNumCalcs,
                usageFallback: `500,000 calculations`,
            }}
            images={{
                avatar: {
                    source: `/images/payhawk-case-study/raquel.png`,
                    altText: 'Raquel Orejas',
                },
                desktop: {
                    source: '/images/payhawk-case-study/payhawk-case-study-box-desktop.png',
                    altText: 'Payhawk card',
                },
                mobile: {
                    source: `url('/images/payhawk-case-study/payhawk-case-study-box-mobile.png')`,
                },
            }}
        />
    )
}

export default PayhawkCaseStudyBox
